<script>
import _findIndex from 'lodash/findIndex'
import { authComputed, merchantComputed, orderComputed } from '@store/helpers'
import { getStoreOption, memberApplicablePrepaidOptions, memberPetOptions } from '@utils/ipetbooking-options'
import { reservationIsExpired } from '@utils/ipetbooking-reservation'
import { orderIsOffline } from '@utils/ipetbooking-order'
import formatPrice from '@utils/format-price'
import formatDate from '@utils/format-date'
import { conditionList } from '@utils/is-condition'
import { formatPaymentMethodIcon } from '@utils/format-payment-method'
import parseISO from 'date-fns/parseISO'
import getISODay from 'date-fns/getISODay'
import { getDefaultReservationDisabledDayList } from '@utils/ipetbooking-get-default'
// import { prepaidFormatGroupAlias } from "@utils/ipetbooking-prepaid";
import _cloneDeep from 'lodash/cloneDeep'
import { memberLevelPriceDiscount } from '@utils/ipetbooking-level'

export default {
  name:'Index5',
  page() {
    return {
      title: '付款',
    }
  },
  components: {
    Layout: () => import('@layout/main'),
    InfoBoxPrepaid: () => import('./components/Index/InfoBoxPrepaid.Jtails'),
    InfoBoxDeposit: () => import('./components/Index/InfoBoxDeposit.Jtails'),
    FormCheckoutStep0: () => import('@components/Form/FormCheckoutStep0.Jtails'),
    FormCheckoutStep2: () => import('@components/Form/FormCheckoutStep2.Jtails'),
  },
  props: {
    cart: {
      type: Object,
      required: true,
    },
    cartType: {
      type: String,
      required: true,
      validator(value) {
        return ['reservation', 'prepaid', 'deposit'].includes(value)
      },
    },
    applicablePrepaidOrderList: {
      type: Array,
      default: () => {
        return []
      },
    },
    isUnpaid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      step: 0,
      submitData: {
        couponCode: '',
        couponInfo: {},

        isUsePrepaid: false,
        prepaidOrderUuid: '',

        fullName: '',
        gender: 'male',
        phoneCode: '+886',
        phoneNumber: '',
        email: '',
        note: '',

        city: '',
        district: '',
        address: '',

        extrafield: {
          byOrder: {},
          bySize: [],
        },

        isAgreeTerms: true,

        petId: '',

        storeAlias: '',
        reservationAlias: '',

        date: new Date(),
        time: '',

        // taxType: 'B2C',
        // taxId: '',
        // CarrierType: '',
        // CarrierNum: '',
        // LoveCode: '',
        // saveTaxInfo: 1,

        paymentMethod: '',
        card: '',
        expMonth: '',
        expYear: '',
        cvc: '',
        bankType: 'BOT',
        scheduleItemIds: [],
        scheduleItems: [],
      },
      isInfoBoxVisible: true,
      infoBoxHeight: 0,
      errorMessage: '',
      checkReservationTimer: null,
      tempPrepaidOrderUuid: '',
      tempDate: '',
      tempTime: '',
      tempReservationAlias: '',
      invalid: false,
      // reservationBannerImage: require(`@assets/images/${$globalProjectName}/reservation/banner_item@2.jpg`),
      // prepaidBannerImage: require('@assets/images/jtails/v2/prepaid/view/banner@2.jpg'),
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    ...orderComputed,
    memberPetOptions,
    storeItem() {
      return getStoreOption({
        value: this.submitData.storeAlias,
        type: 'item',
      })
    },
    disabledDayList() {
      return this.cartType === 'reservation'
        ? getDefaultReservationDisabledDayList({
            storeAlias: this.storeItem.alias,
            type: 'element',
          })
        : []
    },
    formatSubmitText() {
      const isLastStep = this.activeStep === this.stepList.length - 1

      if (isLastStep) {
        if (this.isFreeOrder) {
          return '預約完成'
        } else {
          return '預約完成'
        }
      } else {
        return '下一步'
      }
    },
    hasExtrafieldsByOrderList() {
      const orderExtrafields = this.cart.orderExtrafields || {}
      const orderExtrafieldsByOrder = orderExtrafields.byOrder || []

      return !!orderExtrafieldsByOrder[0]
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrderList
    },
    extrafieldsByOrderList() {
      const isUnpaid = this.$route.name === 'unpaid-checkout'

      if (!this.hasExtrafieldsByOrderList) {
        return []
      }

      return isUnpaid ? [] : this.cart.orderExtrafields.byOrder
    },
    baseCartTotal() {
      if (this.isUnpaid) {
        switch (this.cartType) {
          case 'reservation':
          case 'deposit':
            return this.cart.priceBase
          case 'prepaid':
            return this.cart.basePrice
          default:
            return 0
        }
      } else {
        switch (this.cartType) {
          case 'reservation':
            return this.cart.total
          case 'prepaid':
            return this.cart.prepaid.price
          case 'deposit':
            return this.cart.deposit.price
          default:
            return 0
        }
      }
    },
    priceCartTotal() {
      if (this.isUnpaid) {
        switch (this.cartType) {
          case 'reservation':
          case 'deposit':
            return this.cart.priceTotal
          case 'prepaid':
            return this.cart.price
          default:
            return 0
        }
      } else {
        switch (this.cartType) {
          case 'reservation':
            return this.cart.total
          case 'prepaid':
            return this.cart.prepaid.price
          case 'deposit':
            return this.cart.deposit.price
          default:
            return 0
        }
      }
    },
    couponDiscount() {
      const { discount, type } = this.submitData.couponInfo
      const currentItem = this.isUnpaid ? this.cart.params[0] : this.cart[this.cartType]
      const mathNotSmallThanBaseTotal = (num) => {
        return num > memberLevelPriceDiscount(this.priceCartTotal, currentItem) ? memberLevelPriceDiscount(this.priceCartTotal, currentItem) : num
      }

      if (this.isUnpaid && this.cart.coupon && this.cart.coupon.title) {
        return this.cart.coupon.discountValue
      } else {
        switch (type) {
          case 'fixed':
            return mathNotSmallThanBaseTotal(discount)
          case '%':
            return Math.round(memberLevelPriceDiscount(this.priceCartTotal, currentItem) * (discount / 100))
          default:
            return 0
        }
      }
    },
    cartTotal() {
      const isOrderCartHasCoupon = this.isUnpaid && this.cart.coupon && this.cart.coupon.title
      const currentItem = this.isUnpaid ? this.cart.params[0] : this.cart[this.cartType]
      if (this.isDeductOrder) {
        return this.isUnpaid ? this.priceCartTotal : 0
      } else {
        if (isOrderCartHasCoupon) {
          return memberLevelPriceDiscount(this.priceCartTotal, currentItem)
        } else {
          return memberLevelPriceDiscount(this.priceCartTotal, currentItem) - this.couponDiscount
        }
      }
    },
    isCurrentMemberCart() {
      return this.currentMember?.id === this.cart.memberId || !this.isUnpaid
    },
    isFreeOrder() {
      return this.cartTotal === 0
    },
    isFreeCart() {
      const isFree = () => {
        switch (this.cartType) {
          case 'reservation':
            return this.cart.total === 0
          case 'prepaid':
            if (this.isUnpaid) {
              return this.cart.priceTotal === 0
            } else {
              return this.cart.prepaid.price === 0
            }
          default:
            return false
        }
      }

      return isFree() || !!this.isDeductOrder
    },
    isDeductOrder() {
      return this.submitData.isUsePrepaid && this.prepaidInfo.prepaid?.title
    },
    isOffline() {
      return orderIsOffline({
        order: this.cart,
        ordertype: this.isUnpaid ? 'order' : 'cart',
        type: this.cartType,
      })
    },
    showCoupon() {
      if (this.isUnpaid) {
        if (this.submitData.couponCode && this.isFreeOrder && !this.cart.coupon?.code) {
          return true
        } else {
          return !this.cart.coupon?.code && !this.isFreeOrder
        }
      } else {
        return !this.isDeductOrder
      }
    },
    stepList() {
      return conditionList([
        {
          title: this.cartType === 'reservation' ? '填寫預約資訊' : '填寫會員資訊',
          value: 0,
        },
        {
          title: '填寫付款資訊',
          value: 2,
          condition: () => {
            return true // 因為會員折抵，有機會0元，所以設定給true。原本條件是!this.isFreeOrder
          },
        },
      ])
    },
    activeStep() {
      const index = _findIndex(this.stepList, (item) => {
        return item.value === this.step
      })

      return index !== -1 ? index : this.step
    },
    componentInfoBox() {
      const componentInfoBoxMap = {
        reservation: 'InfoBoxReservation',
        prepaid: 'InfoBoxPrepaid',
        deposit: 'InfoBoxDeposit',
      }

      return componentInfoBoxMap[this.cartType]
    },
    prepaidInfo() {
      const memberApplicablePrepaidOpenOptions = memberApplicablePrepaidOptions({
        prepaidOrderList: this.applicablePrepaidOrderList,
        type: 'open',
      })

      const activeApplicablePrepaidItems = memberApplicablePrepaidOpenOptions.filter((item) => {
        return item.id === this.submitData.prepaidOrderUuid
      })

      return activeApplicablePrepaidItems[0] || {}
    },
    hasUnfinishCheckout() {
      return this.cartType !== 'deposit' && !!this.$store.state.cart.tempCart
    },
    cityOptions() {
      const addressRestrictions = this.cartType === 'reservation' ? this.storeItem.params.addressRestrictions : []

      return addressRestrictions.map((item) => {
        return {
          text: item.city,
          value: item.city,
        }
      })
    },
    districtOptions() {
      const addressRestrictions = this.cartType === 'reservation' ? this.storeItem.params.addressRestrictions : []

      const restrictionItems = addressRestrictions.filter((item) => {
        return item.city === this.submitData.city
      })

      return restrictionItems[0]
        ? restrictionItems[0].district.map((district) => {
            return {
              text: district,
              value: district,
            }
          })
        : []
    },
  },
  watch: {
    cartTotal(value) {
      if (value === 0 && this.step === 2) {
        this.onPrev()
        this.errorMessage = '此訂單免費。請點擊下方「預約完成」按鈕完成預約'
      }
    },
  },
  mounted() {
    const initAutoComplete = () => {
      if (this.hasUnfinishCheckout && this.$route.query.clearTempCart) {
        this.submitData = _cloneDeep(this.$store.state.cart.tempCart.submitData)
        this.$nextTick(() => {
          this.step = this.stepList[this.stepList.length - 1]['value']
        })
        return
      }

      const storeAlias = () => {
        if (this.cartType === 'reservation') {
          return this.cart.param.store.alias
        } else {
          return ''
        }
      }

      const reservationAlias = () => {
        if (this.cartType === 'reservation') {
          return this.cart.param.alias
        } else {
          return ''
        }
      }

      if (this.isUnpaid) {
        const [date, time] = this.cartType === 'reservation' ? this.cart.startDate.split(' ') : ['', '']

        this.submitData = {
          ...this.submitData,
          fullName: this.cart.fullName || '',
          email: this.cart.email || '',
          gender: this.cart.gender || 'male',
          phoneCode: this.cart.phoneCode || '+886',
          phoneNumber: this.cart.phoneNumber || '',
          paymentMethod: this.cart.paymentMethod,
          couponCode: this.cart.coupon?.code || '',
          storeAlias: storeAlias(),
          reservationAlias: reservationAlias(),
          date: parseISO(date),
          time: time.substring(0, 5),
        }
      } else {
        const [phoneCode, phoneNumber] = (this.currentMember.phone || '+886-').split('-')
        const [date, time] = this.cartType === 'reservation' ? (this.cart.inventoryAlias || '').split(' ') : ['', '']

        this.submitData = {
          ...this.submitData,
          fullName: this.currentMember.fullName || '',
          email: this.currentMember.email || '',
          gender: this.currentMember.gender || 'male',
          phoneCode,
          phoneNumber,
          // paymentMethod: this.isOffline
          //   ? 'Cash'
          //   : 'Credit',
          storeAlias: storeAlias(),
          reservationAlias: reservationAlias(),
          date: date ? parseISO(date) : new Date(),
          time: !this.isIncludDisabledDayList(date) ? time : '',
          scheduleItems: !this.isIncludDisabledDayList(date) && !!this.cart?.scheduleItems?.length ? [...this.cart?.scheduleItems] : [],
          scheduleItemIds: !this.isIncludDisabledDayList(date) && !!this.cart?.scheduleItems?.length ? this.cart?.scheduleItems?.map((item) => item.id) : [],
        }
      }
    }

    const initAddress = () => {
      if (this.cartType === 'reservation' && this.storeItem.storeType === 'home') {
        const shippingInfo = this.currentMember?.shippingInfo?.[0] || {}
        const { city, district, address } = shippingInfo

        const initCity = () => {
          const isIncludeCity = this.cityOptions.map((item) => item.value).includes(city)

          this.submitData.city = isIncludeCity ? city : ''
        }
        const initDistrict = () => {
          const isIncludeDistrict = this.districtOptions.map((item) => item.value).includes(district)

          this.submitData.district = isIncludeDistrict ? district : ''
        }
        const initAddress = () => {
          this.submitData.address = this.submitData.city && this.submitData.district ? address : ''
        }

        initCity()
        initDistrict()
        initAddress()
      }
    }

    const initExtrafields = () => {
      if (this.cartType === 'reservation') {
        if (this.hasExtrafieldsByOrderList) {
          ;(this.cart.orderExtrafields.byOrder || []).forEach((extrafield) => {
            if (extrafield.type === 'text') {
              this.submitData.extrafield.byOrder[extrafield.id] = ''
            } else {
              this.submitData.extrafield.byOrder[extrafield.id] = []
            }
          })
        }
      }
    }

    const initDevelopmentAutocomplete = () => {
      if (this.$globalIsDevelopment && !this.isUnpaid) {
        this.submitData.fullName = this.currentMember.fullName || '測試員'
        this.submitData.gender = this.currentMember.gender || 'male'
        this.submitData.email = this.currentMember.email || 'test3@daydream-lab.com'
        this.submitData.note = '備註'

        this.submitData.card = '4000221111111111'
        this.submitData.expMonth = '01'
        this.submitData.expYear = '24'
        this.submitData.cvc = '222'
        this.submitData.bankType = 'BOT'

        if (this.cart.orderExtrafields && this.cartType === 'reservation') {
          ;(this.cart.orderExtrafields.byOrder || []).forEach((extrafield) => {
            if (extrafield.type === 'text') {
              this.submitData.extrafield.byOrder[extrafield.id] = '測試'
            } else if (extrafield.type === 'radio') {
              this.submitData.extrafield.byOrder[extrafield.id] = extrafield.params.options[0].title || ''
            } else {
              this.submitData.extrafield.byOrder[extrafield.id] = [extrafield.params.options[0].title || '']
            }
          })
        }
      }
    }

    const initExtrafieldsFromOrder = () => {
      if (this.cartType === 'reservation' && this.isUnpaid) {
        if (this.hasExtrafieldsByOrderList) {
          ;(this.cart.orderExtrafields.byOrder || []).forEach((extrafield) => {
            this.submitData.extrafield.byOrder[extrafield.id] = extrafield.value
          })
        }
      }
    }

    const initCouponInfoFromOrder = () => {
      if (this.cartType === 'reservation' && this.isUnpaid) {
        if (this.cart.coupon.title) {
          const { discountValue: discount, code, title } = this.cart.coupon

          this.submitData.couponInfo = {
            type: 'fixed',
            discount,
            code,
            title,
          }
        }
      }
    }

    const initPrepaidOrderUuidFromOrder = () => {
      if (this.cart.prepaid && this.cart.prepaid.id) {
        this.submitData.isUsePrepaid = true
        this.submitData.prepaidOrderUuid = this.cart.prepaid.id
        this.submitData.tempPrepaidOrderUuid = this.cart.prepaid.id
      }
    }

    const initExtrafieldfromOrder = () => {
      if (this.isUnpaid) {
        this.$nextTick(() => {
          let extrafield = this.submitData.extrafield.byOrder

          Object.keys(this.cart.byOrderExtrafields || []).forEach((extrafieldId) => {
            const defaultValue = this.cart.byOrderExtrafields[extrafieldId].type === 'checkbox' ? [] : ''

            extrafield = {
              ...extrafield,
              [extrafieldId]: this.cart.byOrderExtrafields[extrafieldId].value || defaultValue,
            }
          })

          this.submitData.extrafield.byOrder = extrafield
        })
      }
    }

    const initPetId = () => {
      if (this.cartType === 'reservation') {
        if (this.isUnpaid) {
          this.submitData.petId = this.cart.pet.id || ''
        } else {
          const cartPetId = () => {
            let value = ''

            if (this.cart.pet) {
              this.memberPetOptions.some((item) => {
                if (item.id === this.cart.pet.id && item.sizeAlias === this.cart.param.sizeAlias) {
                  value = item.id
                  return true
                }
              })
            }

            return value
          }

          const sizeAliasPetId = () => {
            let value = ''

            this.memberPetOptions.some((item) => {
              if (item.sizeAlias === this.cart.param.sizeAlias) {
                value = item.id
                return true
              }
            })

            return value
          }

          this.submitData.petId = cartPetId() || sizeAliasPetId()
        }
      }
    }

    const initCheckReservationTimer = () => {
      setTimeout(() => {
        this.checkExpired()
      }, 300)
      this.checkReservationTimer = setInterval(() => {
        this.checkExpired()
      }, 5000)
    }

    const initShow = () => {
      setTimeout(() => {
        this.show = true
      }, 30)
    }

    const clearTempCart = () => {
      // if (this.$route.query.clearTempCart)
      if (this.cartType !== 'deposit') this.$store.dispatch('cart/setTempCart', null)
    }

    initExtrafieldfromOrder()
    initAutoComplete()
    initExtrafieldsFromOrder()
    initCouponInfoFromOrder()
    initPrepaidOrderUuidFromOrder()
    initPetId()
    initAddress()
    initExtrafields()
    initDevelopmentAutocomplete()
    initCheckReservationTimer()
    initShow()
    clearTempCart()
  },
  destroyed() {
    const clearCheckReservationTimer = () => {
      clearInterval(this.checkReservationTimer)
    }

    clearCheckReservationTimer()
  },
  methods: {
    formatPrice,
    isIncludDisabledDayList(date) {
      return this.disabledDayList.includes(getISODay(parseISO(date)).toString())
    },
    checkExpired(callBack = () => {}) {
      if (!this.isUnpaid && this.cartType === 'reservation') {
        const date = formatDate(this.submitData.date, 'yyyy-MM-dd')
        const time = this.submitData.time

        if (date && time) {
          const isExpired = reservationIsExpired({
            dateTime: `${date} ${time}`,
            storeAlias: this.storeItem.alias,
          })

          if (isExpired) {
            clearInterval(this.checkReservationTimer)
            const alertDate = formatDate(`${date} ${time}`, 'yyyy/MM/dd (EEE) HH:mm')

            this.$alert(`超過最晚可預約時間，請預約其他時段<br><span class="text-gray-2 fs-2sm">您預約的時段: ${alertDate}</span>`, {
              title: `提示`,
              showClose: false,
              dangerouslyUseHTMLString: true,
            }).then(() => {
              const goToReservation = () => {
                this.$router.replace({
                  name: 'reservation-item',
                  params: {
                    reservationAlias: this.submitData.reservationAlias,
                  },
                  query: {
                    date: date,
                    section: 'date',
                  },
                })
              }
              this.submitData.time = ''

              if (this.activeStep > 1) {
                this.activeStep = 1
                this.scrollToId('time')
              } else {
                goToReservation()
              }
            })
          } else {
            callBack()
          }
        }
      } else {
        callBack()
      }
    },
    onClickStep(step) {
      if (step < this.step) {
        this.step = step
        this.scrollToSectionStep()
      }
    },
    scrollToSectionStep() {
      if (this.$globalBreakpoint === 'xs' || this.$globalBreakpoint === '2sm' || this.$globalBreakpoint === 'sm' || this.$globalBreakpoint === 'md') {
        this.$scrollToElement({
          y: 0,
        })
      } else {
        this.$scrollToElement({
          $el: this.$refs['sectionStep'],
          offset: 160,
        })
      }
    },
    async onSubmitStep() {
      const isLastStep = this.activeStep === this.stepList.length - 1

      if (isLastStep) {
        const isValidate = await this.$refs[`FormCheckoutStep${this.step}`].validateAndMoveFocus()
        if (!isValidate) return
        this.tryToCheckoutCart()

        this.isInfoBoxVisible = false
      } else {
        const nextStepFn = () => {
          this.step = this.stepList[this.activeStep + 1].value

          this.$nextTick(() => {
            this.scrollToSectionStep()
          })

          this.isInfoBoxVisible = false
        }
        nextStepFn()
      }
    },
    async tryToStoreCart() {
      await this.$store
        .dispatch('cart/storeCart', {
          prepaidOrderUuid: this.submitData.prepaidOrderUuid || undefined,
          inventoryAlias: `${formatDate(this.submitData.date)} ${this.submitData.time}`,
          params: [
            {
              alias: this.submitData.reservationAlias,
              qty: 1,
            },
          ],
          scheduleItemIds: [...this.submitData.scheduleItemId],
        })
        .then(() => {
          return true
        })
    },
    onPrev() {
      const isFirstStep = this.activeStep === 0

      if (isFirstStep) {
        const goToBack = () => {
          this.$router.go(-1)
        }

        goToBack()
      } else {
        this.step = this.stepList[this.activeStep - 1].value

        this.$nextTick(() => {
          this.scrollToSectionStep()
        })
      }
    },
    tryToCheckoutCart() {
      const paymentMethod = () => {
        /* if(this.isUnpaid && this.submitData.isUsePrepaid && this.submitData.prepaidOrderUuid) { */
        if (!this.isUnpaid && this.submitData.isUsePrepaid && this.submitData.prepaidOrderUuid) {
          return 'Prepaid'
        } else if (this.isFreeOrder) {
          return ''
        } else {
          return this.submitData.paymentMethod
        }
      }

      const paymentMethodIcon = paymentMethod() ? formatPaymentMethodIcon(paymentMethod()) : this.submitData.isUsePrepaid ? formatPaymentMethodIcon('Prepaid') : 'fal fa-circle-notch'

      const loadingMaskCheckOutCart = this.$loading({
        lock: true,
        text: '正在處理您的訂單',
        spinner: `${paymentMethodIcon} fa-spin`,
        background: 'rgba(81, 176, 202, 0.3)',
        customClass: 'isStyleCheckout',
      })

      const orderExtrafieldsFromOrder = () => {
        const orderExtrafieldsByOrder = Object.keys(this.submitData.extrafield.byOrder).map((key) => {
          return {
            id: key,
            value: Array.isArray(this.submitData.extrafield.byOrder[key]) ? this.submitData.extrafield.byOrder[key].join('/') : this.submitData.extrafield.byOrder[key],
          }
        })

        let orderExtrafieldsBySize = []

        return {
          byOrderExtrafields: orderExtrafieldsByOrder,
          bySizeExtrafields: orderExtrafieldsBySize,
        }
      }

      const orderExtrafieldsCart = () => {
        const orderExtrafieldsByOrder = Object.keys(this.submitData.extrafield.byOrder).map((key, index) => {
          return {
            id: key,
            group: index + 1,
            Alias: '',
            value: Array.isArray(this.submitData.extrafield.byOrder[key]) ? this.submitData.extrafield.byOrder[key].join('/') : this.submitData.extrafield.byOrder[key] || '',
          }
        })

        let orderExtrafieldsBySize = []

        return {
          orderExtrafields: [...orderExtrafieldsByOrder, ...orderExtrafieldsBySize],
        }
      }

      const orderExtrafields = this.isUnpaid ? orderExtrafieldsFromOrder() : orderExtrafieldsCart()

      /* const CarrierNum = () => {
       return this.submitData.CarrierType === '2'
       ? this.submitData.phoneNumber
       : this.submitData.CarrierNum
       }; */

      this.$store
        .dispatch('cart/checkOutCart', {
          cart: {
            ...this.submitData,
            ...orderExtrafields,
            couponCode: this.showCoupon ? this.submitData.couponCode : undefined,
            paymentMethod: paymentMethod(),
            card: this.submitData.card.replace(/\s/g, ''),
            basePrice: this.isFreeCart ? 0 : this.baseCartTotal,
            total: this.cartTotal,
            // CarrierNum: CarrierNum(),
          },
          cartType: this.cartType,
          orderId: this.cart.id,
        })
        .then((response) => {
          const isRedirectToOrder = response && response.hasOwnProperty('items')

          const goToOrderDetail = () => {
            switch (this.cartType) {
              case 'reservation':
                this.$router.replace({
                  name: 'reservation-checkout-detail',
                  params: {
                    orderId: response.items.id,
                  },
                  query: {
                    status: 'SUCCESS', // EXPIRED
                    message: '',
                  },
                })
                break
              case 'prepaid':
                this.$router.replace({
                  name: 'prepaid-checkout-detail',
                  params: {
                    orderId: response.items.id,
                  },
                  query: {
                    status: 'SUCCESS', // EXPIRED
                    message: '',
                  },
                })
                break
              case 'deposit':
                this.$router.replace({
                  name: 'deposit-checkout-detail',
                  params: {
                    containerUuId: response.items.id,
                  },
                  query: {
                    status: 'SUCCESS', // EXPIRED
                    message: '',
                  },
                })
                break
            }
          }

          const handle3DVerify = () => {
            document.getElementById('app').innerHTML = response
            document.forms[0].submit()
          }

          isRedirectToOrder ? goToOrderDetail() : handle3DVerify()
        })
        .catch((err) => {
          const errMessage = err.data.Message || this.$t(`error.${err.status}`)

          this.$alert(errMessage, {
            customClass: 'isStyleBase',
            title: this.cartType === 'reservation' ? '預約錯誤' : '結帳錯誤',
            confirmButtonText: '確定',
            showClose: false,
          }).then(() => {
            const goToReservation = () => {
              this.$router.replace({
                name: 'reservation-item',
                params: {
                  storeAlias: this.submitData.storeAlias,
                  reservationAlias: this.submitData.reservationAlias,
                },
              })
            }

            const goToPrepaid = () => {
              this.$router.replace({
                name: 'prepaid-item',
                params: {
                  // prepaidAlias: prepaidFormatGroupAlias(this.cart.prepaid.alias),
                  prepaidAlias: this.cart.prepaid.groupAlias,
                },
              })
            }

            const goToDeposit = () => {
              this.$router.replace({
                name: 'deposit',
              })
            }

            const goToDepositOrder = () => {
              this.$router.replace({
                name: 'member-deposit-item',
                params: {
                  depositOrderId: this.cart.id,
                },
              })
            }

            switch (this.cartType) {
              case 'reservation':
                goToReservation()
                break
              case 'prepaid':
                goToPrepaid()
                break
              case 'deposit':
                if (this.cart.id) {
                  goToDepositOrder()
                } else {
                  goToDeposit()
                }
                break
            }
          })
        })
        .finally(() => {
          loadingMaskCheckOutCart.close()
        })
    },
    formatBanner() {
      switch (this.cartType) {
        case 'prepaid':
          return {
            title: `購買${this.currentMerchant.prepaidSetting.title || '包套方案'}`,
            description: '請填寫下方資訊以完成購買',
          }
        case 'deposit':
          return {
            title: '購買儲值方案',
            description: '請填寫下方資訊以完成購買',
          }
        case 'reservation':
        default:
          if (this.isUnpaid) {
            return {
              title: '預約付款',
              description: '請填寫下方資訊以完成預約',
            }
          } else {
            return {
              title: `${this.currentMerchant?.cosmeticSetting?.title || '線上預約'}`,
              description: '請填寫下方資訊以完成預約',
            }
          }
      }
    },
  },
}
</script>
<!-- section template -->
<template>
  <Layout :class="$style.viewCheckout">
    <transition name="el-fade-in-linear">
      <div v-show="show">
        <div :class="$style.infoBoxMobile" class="d-md-none">
          <div class="infoBoxMobile__btn" :class="{ isOpen: isInfoBoxVisible }" @click="isInfoBoxVisible = !isInfoBoxVisible">
            <span class="infoBoxMobile__title">
              <i class="fal fa-calendar-plus mr-2"></i>
              <span>預約明細</span>
              <i class="fas fa-caret-down ml-1"></i>
            </span>
            <div class="infoBoxMobile__price">
              {{ formatPrice(cartTotal) }}
            </div>
          </div>
          <component
            :is="componentInfoBox"
            class="viewCheckout__infoBox"
            :class="{ showInfoBox: isInfoBoxVisible }"
            :cart="cart"
            :submit-data.sync="submitData"
            :cart-total="cartTotal"
            :is-free-order="isFreeOrder"
            :is-unpaid="isUnpaid"
            :show-coupon="showCoupon"
            :coupon-discount="couponDiscount"
            :prepaid-info="prepaidInfo"
          />
        </div>
        <!-- <BaseBannerJtails
          :title="formatBanner().title"
          :image="bannerImage"
          class="d-none d-md-flex"
        /> -->
        <div>
          <div class="container">
            <div class="section pt-5">
              <div class="row">
                <div class="col-12">
                  <div ref="sectionStep" :class="$style.sectionStep">
                    <div class="sectionStep__leftText" :class="{ isStyleDingBeauty: $globalIsDingBeauty }">
                      預約付款
                    </div>
                    <el-steps :active="activeStep" class="isStyleBase sectionStep__step" :class="{ isStyleDingBeauty: $globalIsDingBeauty }">
                      <el-step
                        v-for="(stepItem, $index) in stepList"
                        :key="$index"
                        :title="stepItem.title"
                        :class="`isStyle-${stepItem.title.length}`"
                        @click.native="onClickStep(stepItem.value)"
                      ></el-step>
                    </el-steps>
                  </div>
                </div>
                <div class="col-md-7 col-lg-8 viewCheckout__leftBox">
                  <section :class="$style.sectionForm">
                    <div v-if="!!errorMessage" class="mb-3">
                      <el-alert :title="errorMessage" type="warning" show-icon class="isStyleBase"> </el-alert>
                    </div>
                    <component
                      :is="`FormCheckoutStep${step}`"
                      :ref="`FormCheckoutStep${step}`"
                      v-model="submitData"
                      :type="cartType"
                      :extrafields-by-order-list="extrafieldsByOrderList"
                      :temp-date.sync="tempDate"
                      :temp-time.sync="tempTime"
                      :cart="cart"
                      :cart-total="cartTotal"
                      :is-free-order="isFreeOrder"
                      :is-offline="isOffline"
                      :is-unpaid="isUnpaid"
                      :is-current-member-cart="isCurrentMemberCart"
                      :loading="
                        $isLoading('checkOutCart') ||
                          $isLoading('checkoutAddOrderItem') ||
                          $isLoading('deductReservationOrderItem') ||
                          ($isLoading('storeCart') && activeStep === 0 && cartType === 'reservation')
                      "
                      :invalid.sync="invalid"
                      :applicable-prepaid-order-list="applicablePrepaidOrderList"
                      :show-coupon="showCoupon"
                      :coupon-discount="couponDiscount"
                      :prepaid-info="prepaidInfo"
                      @submit="onSubmitStep"
                      @prev="onPrev"
                    />
                  </section>
                </div>
                <div class="col-md-5 col-lg-4 viewCheckout__rightBox">
                  <BaseSticky :offset="0" :menu-height="90" :space-top="40" :space-bottom="40">
                    <component
                      :is="componentInfoBox"
                      class="viewCheckout__infoBox d-none d-md-block"
                      :submit-data.sync="submitData"
                      :cart="cart"
                      :cart-total="cartTotal"
                      :is-free-order="isFreeOrder"
                      :is-unpaid="isUnpaid"
                      :show-coupon="showCoupon"
                      :coupon-discount="couponDiscount"
                      :prepaid-info="prepaidInfo"
                      :invalid="invalid"
                      :format-submit-text="formatSubmitText"
                      @submit="onSubmitStep"
                    />
                  </BaseSticky>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BasePre>isOffline: {{ isOffline }}</BasePre>
        <BasePre>cart: {{ cart }}</BasePre>
        <BasePre>applicablePrepaidOrderList: {{ applicablePrepaidOrderList }}</BasePre>
        <BasePre>prepaidInfo: {{ prepaidInfo }}</BasePre>
        <BasePre>couponDiscount: {{ couponDiscount }}</BasePre>
        <BasePre>activeStep: {{ activeStep }}</BasePre>
        <BasePre>isCurrentMemberCart: {{ isCurrentMemberCart }}</BasePre>
        <BasePre>showCoupon: {{ showCoupon }}</BasePre>
      </div>
    </transition>
  </Layout>
</template>
<!-- section style -->
<style lang="scss" module>
.viewCheckout {
  @include max-md {
    padding-bottom: 57px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 57px) !important;
    padding-bottom: calc(env(safe-area-inset-bottom) + 57px) !important;
  }

  :global {
    .viewCheckout {
      &__leftBox {
        padding-right: 87px;

        @include max-xl {
          padding-right: #{$grid-gutter-width / 2};
        }
      }

      &__rightBox {
        @include unstyled;
      }

      &__infoBox {
        @include max-md {
          position: static;
          top: 0;
          height: max-content;
          max-height: 0;
          padding-top: 0;
          padding-bottom: 0;
          margin-top: -1px;
          overflow: hidden;
          transition: max-height 0.6s, padding 0.6s;

          &.showInfoBox {
            max-height: 900px;
            padding-top: 2.25rem;
            padding-bottom: 2.25rem;
            margin-top: 0;
          }
        }
      }
    }

    hr {
      @include max-md {
        margin: 0.5rem 0 1.4rem;
      }
    }
  }
}

.sectionForm {
  :global {
    .sectionForm {
      @include unstyled;
    }
  }
}

.infoBoxMobile {
  background-color: rgba($color-primary, 10%);

  :global {
    .infoBoxMobile {
      &__btn {
        position: relative;
        z-index: 1000;
        display: flex;
        justify-content: space-between;
        padding: 1rem $container-gap 1rem;
        cursor: pointer;
        background-color: rgba($color-primary, 10%);
        border-bottom: $color-gray-4 1px solid;
      }
    }
  }
}

.sectionStep {
  margin-bottom: 3rem;
  border-bottom: 1px solid $color-line;
  display: flex;
  align-items: center;
  padding-bottom: 2rem;
  :global {
    .sectionStep {
      &__leftText {
        font-size: 1.125rem;
        width: 150px;
        @include max-md {
          display: none;
        }
        &.isStyleDingBeauty {
          margin-bottom: 1.5rem;
        }
      }
      &__step {
        width: 100%;
      }
    }
  }
}
</style>
